const ROUTES = {
  ENTER: "/",
  MAIN: "/main",
  COMICS: "/comic/:id",
  EVENTS: "/event/:id",
  SERIES: "/serie/:id",
  CHARACTERS: "/character/:id",
};

export default ROUTES;
